export const size = {
  methods: {
    //takes in a colorway size array and returns the first size that has available inventory
    returnFirstSizeWithAvailableInventory(sizeArray) {
      try {
        if (sizeArray.length > 0) {
          //select the first size that has inventory. (size array should be sorted at this point.)
          //TODO: can remove the check for 'bundle' once we switch over to new bundle system that works better
          let firstAvailable = sizeArray.find((size) => {
            if (
              size.available > 0 &&
              !size.name.toLowerCase().includes('bundle')
            ) {
              return true;
            }
          });

          //if no available sizes, return first.
          if (typeof firstAvailable === 'undefined') {
            return sizeArray[0];
          } else {
            return firstAvailable;
          }
        } else {
          //return error if we don't have an array with some length.
          return sizeArray[0];
        }
      } catch (error) {
        //console.log(error);
        return -1;
      }
    },

    //creating functions here to determine if Vue templates should display this sizing chart link.
    //leveraged on OLD product-detail + livewire-pdp templates
    shouldDisplaySizeChartByProductType(productType) {
      let productTypesWithSize = [
        'apparel',
        't-shirts',
        'accessories',
        'bottoms',
        'fleece',
        'headwear',
        'insulation',
        'logowear',
        'rainwear',
        'tops',
        'wind jackets',
      ];

      //check types for need to display size chart
      if (productTypesWithSize.includes(productType.toLowerCase())) {
        return true;
      }
      return false;
    },

    //leveraged on OLD product-detail + livewire-pdp templates
    shouldDisplaySizeChartByProductTitle(productTitle) {
      //Sock sizing chart is currently for the bombas collab. If we get other products with 'sock' in title, logic will need to be more specific
      let productTitlesWithSize = ['sock', 'gooddog collar'];

      //check titles for need to display size chart
      if (productTitlesWithSize.includes(productTitle.toLowerCase())) {
        return true;
      }
      return false;
    },

    // This function takes in a string, and sorts the size array from smallest to largest sizes.
    sizeToNumberConverter(sizeSlug) {
      //if our size string is a number, just use the number for sorting.
      if(!isNaN(sizeSlug)) {
        return parseInt(sizeSlug);
      }

      //if size string is not a number, assign it one for the purpose of sorting.
      switch (sizeSlug.toLowerCase()) {
        case 'xxs':
          return 1;
          break;
        case 'xs':
          return 2;
          break;
        case 's':
          return 3;
          break;
        case 'm':
          return 4;
          break;
        case 'l':
          return 5;
          break;
        case 'xl':
          return 6;
          break;
        case 'xxl':
          return 7;
          break;
        case 'xxxl':
          return 8;
          break;
        case '1X':
          return 9;
          break;
        case '2X':
          return 10;
          break;
        case '3X':
          return 11;
          break;
        case '4X':
          return 12;
          break;
        default:
          return 13;
          break;
      }
    },

    sortSizeArray(selectedColor) {
      if (selectedColor.sizes && selectedColor.sizes.length > 1) {
        selectedColor.sizes.sort((a, b) => {
          return (
            this.sizeToNumberConverter(a.slug) -
            this.sizeToNumberConverter(b.slug)
          );
        });
      }
    },
  },
};
